import React from 'react';
import filter from '../../filter';
import ListStats from '../ListStats';
import ListMap from '../ListMap';
import ListResults from '../ListResults';
import shallowequal from 'shallowequal';
import request from 'arcdynamic-request';
import {V7_PROPERTIES_MAP, V7_PROPERTIES_STATS} from '../../consts/queries';

const limit = 1000;

export default class ListingMap extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			items: null,
			totalCount: null,
			stats: null,
			error: null,
			isBusy: null,
			query: this.props.location.query,
		};
	}

	componentDidMount() {
		this.fetch(this.props.location.query);
	}

	fetch(q) {
		this.setState({isBusy: true});

		const query = {...q};
		const options = filter(query);
		options.param.limit = limit;
		options.param.offset = query.page ? ((Number(query.page) - 1)*limit) : 0;

		Promise.all([
			request(arc.path.api, {
				service: 'arcimedes',
				action: 'open.dataquery.execute',
				params: [V7_PROPERTIES_MAP],
				options,
			}, {
				expires: 1000*10
			}),
			request(arc.path.api, {
				service: 'arcimedes',
				action: 'open.dataquery.execute',
				params: [V7_PROPERTIES_STATS],
				options,
			}, {
				expires: 1000*10
			}),
		]).then(values => {
			this.setState({
				items: values[0].success ? values[0].data : null,
				totalCount: values[1].data && values[1].data.length && typeof values[1].data[0].count === 'string' ? Number(values[1].data[0].count) : limit,
				stats: values[1].data[0],
				error: values[0].success ? null : values[0].message,
				isBusy: null,
				query,
			});
		});
	}

	componentDidUpdate(prevProps) {
		if (!shallowequal(prevProps.location.query, this.props.location.query)) {
			this.fetch(this.props.location.query);
		}
	}

	render() {
		return (
			<div className='ListingMap' data-is-busy={this.state.isBusy}>
				<ListStats stats={this.state.stats} query={this.state.query}/>
				<ListMap listings={this.state.items}/>
				<ListResults query={this.props.location.query} pathname={this.props.location.pathname} error={this.state.error} totalCount={this.state.totalCount} itemCount={this.state.items ? this.state.items.length : false} limit={limit}/>
			</div>
		);
	}
}
